import AllasPlusLogo from '@/allas/public/image/allas-plus-logo.svg';
import { StandaloneComponent } from '@/types/component';
import {
  StandaloneArticleTeaserDefault,
  StandaloneArticleTeaserDefaultProps,
} from 'base/components/ArticleTeaser/Default';

export const AllasStandaloneArticleTeaserDefault: StandaloneComponent<StandaloneArticleTeaserDefaultProps> = (
  props,
) => {
  return <StandaloneArticleTeaserDefault subscriptionLogo={<AllasPlusLogo />} {...props} />;
};
